$(function() {
	// celkovy pocet osob
	$('#nl_adults').change(function() { 
		$('#nl_sum_person').val(($('#nl_adults').val() * 1) + ($('#nl_children').val() * 1));
	});
	
	$('#nl_children').change(function() { 
		$('#nl_sum_person').val(($('#nl_adults').val() * 1) + ($('#nl_children').val() * 1)); 
	});

	// form submit
	$('#trip_group').submit(function() {
		$('#nl_selected_countries_id option').attr('selected','selected');
	});
});
